import type {Relation} from "typeorm";
import {ChildEntity, JoinTable, ManyToMany, ManyToOne, OneToMany, RelationId} from "typeorm";
import {Division} from "./Division";
import {TableStatistics} from "@/modules/competitions/entity/TableStatistics";
import {Team} from "@/modules/team/entity";

@ChildEntity()
export class LeagueDivision extends Division {
  @OneToMany(() => TableStatistics, stats => stats.division)
  stats: TableStatistics[];

  @ManyToMany(() => Team , {nullable: true})
  @JoinTable()
  promoted?: Relation<Team[]>;

  @RelationId((m: LeagueDivision) => m.promoted)
  promotedIds?: number[];

  @ManyToMany(() => Team , {nullable: true})
  @JoinTable()
  relegated?: Relation<Team[]>;

  @RelationId((m: LeagueDivision) => m.relegated)
  relegatedIds?: number[];
}
